import { ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material";
import { useContext } from "react";

import DataContext from "../../../../../../../../context/DataContext";
import { useHistoryNavigate } from "../../../../../../../../hooks/useHistoryNavigate";
import ApiServices from "../../../../../../../api/service";
import FormatISODateTime from "../../../../../../../global/FormatISODateTime";
import { NotificationPageDispatchContext } from "../../context/NotificationsPageProvider";
import {
  setShouldFetchNotifications,
} from "../../state/actions";

import NotificationAvatar from "./NotificationAvatar";
import NotificationsItemtype from "./NotificationsItemType";
import NotificationTooltip from "./NotificationTooltip";

const NotificationsItem = ({ item }) => {
  const dispatch = useContext(NotificationPageDispatchContext);
  const { accessToken } = useContext(DataContext);
  const { historyNavigate } = useHistoryNavigate();

  function navigateToCaseDetail(id) {
    historyNavigate("client-detail", id);
  }
  const getCaseId = (related, itemId) => {
      const caseId = related.filter((item) => item.type === "case");
      ApiServices.postData(`api/core/notifications/read/`, [itemId], accessToken)
        .then((res) => {
          setShouldFetchNotifications(dispatch, true);
          return res;
        })
        .catch((err) => console.log(err));
      if (caseId.length > 0) {
         navigateToCaseDetail(caseId[0].id);
      }

  };

  
  return (
    <ListItem
      alignItems="flex-start"
      sx={{ borderBottom: "solid #eee 1px" }}
      className={`my-3 ${
        item.seen_time ? "bg-white" : "bg-blue-50"
      } cursor-pointer transition-all duration-200 hover:bg-gray-100`}
      onClick={() => getCaseId(item?.related_to, item.id)}
    >
      <ListItemAvatar className="w-[10%]">
        <NotificationAvatar item={item} />
      </ListItemAvatar>
      <ListItemText
        className="w-[84%]"
        primary={
          <p>
            <span className="mr-1 font-bold">{item?.sender?.name || ""}</span>
            <span className="mr-1">{item?.display_text}</span>
            <NotificationTooltip title={FormatISODateTime(item?.notification_sent)}>
              <Typography component="span" className="text-gray-500 hover:text-blue-500">
                {item?.relative_notification_sent}
              </Typography>
            </NotificationTooltip>
          </p>
        }
        secondary={
          item?.related_to.length > 0 &&
          item?.related_to.map((related) => <NotificationsItemtype item={related} />)
        }
      />
    </ListItem>
  );
};
export default NotificationsItem;